<template>
	<div>
		<div class="mt-4">
			<div class="row justify-content-center">
				<div class="col-8">
					<viewReport :report_id="$route.params.report_id" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import viewReport from './ViewReport.vue'

	export default {
		components: {
			viewReport
		}

	}
</script>